// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"342b95af","885":"2f0821c6","977":"b0a8bb84"}[chunkId] + ".chunk.js";
};